/* ═══════════════════════════════════════════════════════════════
   SmartBlockService — READ-ONLY catalog access.

   Smart blocks are CUT (docs/MASTERS_LADDER_PLAN.md §0; R5 removed every
   smart-block surface app-wide). What survives is the DATA: firms already
   have `smart_blocks` rows, and spec documents already carry smart-token
   blocks that must keep resolving to exactly the same text at export.

   So this service kept its two read paths — the export pipeline reads the
   firm catalog to resolve those tokens — and lost every authoring path
   (save / delete / archive / restore / drafts / review / approve), which
   existed only for the deleted Smart Blocks page. The tables themselves are
   untouched; nothing here writes.
   ═══════════════════════════════════════════════════════════════ */

import type { SmartBlock } from '../../shared/types';
import * as cache from './cloudCache';
import type { TableOpts } from './cloudCache';

const smartBlockOpts: TableOpts = {
  jsonFields: [
    'tags',
    'paramSchema',
    'defaultParams',
    'querySpec',
    'versionHistory',
    'editHistory',
  ],
};

export const SmartBlockService = {
  /** The firm's published smart blocks. Used by the export pipeline to
   *  resolve smart-token blocks that already live in documents. */
  list: async (): Promise<SmartBlock[]> => cache.list<SmartBlock>('smart_blocks', smartBlockOpts),

  get: async (id: string): Promise<SmartBlock | null> => {
    const all = await SmartBlockService.list();
    return all.find((sb) => sb.id === id) ?? null;
  },
};
